import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["renderAs", "iconBefore", "iconAfter"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import styled from "styled-components";
import { forwardRef } from "react";
import { SelectLink } from "@interdependence-ui";
import { SearchableSelectLink } from "@interdependence-ui";
import { PrimaryButtonLink, PrimaryButton } from "@base-ui";
import { jsx as _jsx } from "react/jsx-runtime";
export var headerHeight = "54px";
export var NavButton = styled( /*#__PURE__*/forwardRef(function (_ref, ref) {
  var renderAs = _ref.renderAs,
    iconBefore = _ref.iconBefore,
    iconAfter = _ref.iconAfter,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsx(PrimaryButtonLink, _objectSpread(_objectSpread({}, rest), {}, {
    renderAs: renderAs,
    iconBefore: iconBefore || "null",
    iconAfter: iconAfter || "null",
    ref: ref
  }));
})).withConfig({
  displayName: "headerstyles__NavButton",
  componentId: "sc-82f9s1-0"
})(["width:fit-content;text-decoration:none;", ""], function (_ref2) {
  var theme = _ref2.theme;
  return "\n    background: ".concat(theme.colors.P1, ";\n    color: ").concat(theme.colors.G1, ";\n    display: inline-flex;\n    border-radius: 0;\n    box-shadow: none;\n    font-size: 1.4rem;\n    padding: 0 2rem;\n    height: ").concat(headerHeight, ";\n    line-height: ").concat(headerHeight, ";\n  ");
});
export var ExternalNavButton = styled(function (props) {
  return /*#__PURE__*/_jsx(PrimaryButton, _objectSpread({
    as: "a"
  }, props));
}).withConfig({
  displayName: "headerstyles__ExternalNavButton",
  componentId: "sc-82f9s1-1"
})(["width:fit-content;text-decoration:none;", ""], function (_ref3) {
  var theme = _ref3.theme;
  return "\n    background: ".concat(theme.colors.P1, ";\n    color: ").concat(theme.colors.G1, ";\n    border-radius: 0;\n    box-shadow: none;\n    font-size: 1.4rem;\n    padding: 0 2rem;\n    height: ").concat(headerHeight, ";\n    line-height: ").concat(headerHeight, ";\n  ");
});
export var NavSelect = styled(function (props) {
  return /*#__PURE__*/_jsx(SelectLink, _objectSpread({}, props));
}).withConfig({
  displayName: "headerstyles__NavSelect",
  componentId: "sc-82f9s1-2"
})(["", ""], function (_ref4) {
  var theme = _ref4.theme;
  return "\n    button{\n      box-shadow: none;\n      background: ".concat(theme.colors.P1, ";\n      color: ").concat(theme.colors.G1, ";\n      height: ").concat(headerHeight, ";\n      line-height: ").concat(headerHeight, ";\n      border-radius: 0;\n      padding: 0 2rem;\n      font-size: 1.4rem;\n      justify-content: center;\n      font-family: ").concat(theme.fonts.robotoRegular, ";\n      &:after{\n        position: relative;\n        font-size: 1.6rem;\n        line-height: 1.6rem;\n        top: 0.2rem;\n        left: 1rem;\n        right: 0;\n      }\n    }\n    button[aria-expanded='true']{\n      background: ").concat(theme.colors.i2, ";\n      color: ").concat(theme.colors.P0, ";\n    }\n    ul{\n      width: fit-content;\n    }\n    li a{\n      font-size: 1.4rem;\n    }\n  ");
});
export var MeasuresSearch = styled(function (props) {
  return /*#__PURE__*/_jsx(SearchableSelectLink, _objectSpread({}, props));
}).withConfig({
  displayName: "headerstyles__MeasuresSearch",
  componentId: "sc-82f9s1-3"
})(["", ""], function (_ref5) {
  var theme = _ref5.theme;
  return "\n    margin: auto 0 auto 2rem;\n    width: 400px;\n    div[role=\"search\"] > div{\n      &:focus-within{\n        box-shadow: none;\n      }\n    }\n    input{\n      background: ".concat(theme.colors.G1, ";\n      height: 40px;\n      box-shadow: none;\n      &:focus, &:active{\n        box-shadow: none;\n      }\n    }\n    ul{\n      border: none;\n      box-shadow: 0 0 0 1px ").concat(theme.colors.G4).concat(theme.colors.opacitySuffix[3], ";\n      border-radius: 6px;\n      margin-top: 2px;\n    }\n  ");
});